import React from 'react'

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">

        </h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        React Js
                        </h3>
                        <span className="skills__level">
                        Advanced
                        </span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        JavaScript
                        </h3>
                        <span className="skills__level">
                        Advanced
                        </span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        BootStrap
                        </h3>
                        <span className="skills__level">
                        Intermediate

                        </span>
                    </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        Tailwind CSS
                        </h3>
                        <span className="skills__level">
                        Advanced
                        </span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        Git
                        </h3>
                        <span className="skills__level">
                        Intermediate
                        </span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">
                        SASS
                        </h3>
                        <span className="skills__level">
                        Intermediate
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend